export const POIS = "pois";
export const AMENITIES = "amenities";
export const USERDATA = "userdata";
export const USERVISITS = "uservisits";
export const USERTOURS = "usertours";
